export default __webpack_public_path__ + "static/media/3_CertificatoISO45001n2465em1.7447e176.pdf";